import { ENVIRONMENT_LINK_ENDPOINTS_NAMES } from '@constants/common/environmentLinkEndpointNames';
import { HEADER_LINKS_TYPES, EXTRA_ACTIONS } from '../constants/headerLinkTypes';
import { ALL_USER_ROLES } from '@constants/roles/userRoleTypes';
import { ssapModalTypes as MODAL_TYPES } from '@constants/ssap/modals/ssapModalTypes';
import { configs } from '@constants/configs/configs';
import { onLogout } from '@utils/localStorage/sessionStorageUtils';
import { IEX_STATE_CODES } from '@constants/configs/states';

const {
    routes
} = configs;

export const georgiaHeaderLogo = {
    link: true,
    tagline: false
};

export const georgia = {
    linkDetails: [
        {
            name: 'language',
            className: ['usa-nav__primary-item gi-main__nav__primary-item link__language'],
            linkClassName:['gi-main__nav__primary-item__link'],
            text: 'header.lang',
            path: '#',
            type: HEADER_LINKS_TYPES.LANGUAGE_SWITCH,
            visible: environment => environment.anonymous || environment.impersonation || environment.user && environment.user.role === ALL_USER_ROLES.INDIVIDUAL,
            externalLink: ''
        },
        {
            name: 'login',
            text: 'header.login',
            className: ['usa-nav__primary-item gi-main__nav__primary-item'],
            linkClassName:['usa-nav__link gi-main__nav__primary-item__link'],
            path: ENVIRONMENT_LINK_ENDPOINTS_NAMES.LOGIN,
            type: HEADER_LINKS_TYPES.LINK,
            visible: environment => environment.anonymous,
            externalLink: ''
        },
        {
            name: 'home',
            text: 'header.home',
            textClassname: ['usa-sr-only'],
            className: ['usa-nav__primary-item gi-main__nav__primary-item'],
            linkClassName:['usa-nav__link gi-main__nav__primary-item__link'],
            symbols: ['home'],
            path: ENVIRONMENT_LINK_ENDPOINTS_NAMES.DASHBOARD,
            type: HEADER_LINKS_TYPES.ICON,
            visible: (environment, currentPath, telexEnabled, errorStatus) => !environment.anonymous && !errorStatus,
            externalLink: ''
        },
        {
            name: 'secured-mail',
            text: 'header.inbox',
            textClassname: ['usa-sr-only'],
            className: ['usa-nav__primary-item gi-main__nav__primary-item'],
            linkClassName:['usa-nav__link gi-main__nav__primary-item__link secured-mail'],
            symbols: ['envelope'],
            path: ENVIRONMENT_LINK_ENDPOINTS_NAMES.UNREAD_MESSAGES,
            type: HEADER_LINKS_TYPES.ICON,
            visible: (environment, currentPath, telexEnabled, errorStatus) => !telexEnabled && !environment.anonymous && !errorStatus,
            showUnreadMessage: true,
            externalLink: ''
        },
        {
            name: 'secured-mail-telex',
            text: 'header.inbox',
            textClassname: ['usa-sr-only'],
            className: ['usa-nav__primary-item gi-main__nav__primary-item'],
            linkClassName: ['usa-nav__link gi-main__nav__primary-item__link secured-mail'],
            symbols: ['envelope'],
            path: routes.NEW_INBOX_HOME,
            type: HEADER_LINKS_TYPES.ICON_REACT_ROUTER,
            visible: (environment, currentPath, telexEnabled, errorStatus) => telexEnabled && !environment.anonymous && !errorStatus,
            showUnreadMessage: true,
            externalLink: ''
        },
        {
            name: 'get-assistance',
            text: 'header.getAssistance',
            className: ['usa-nav__primary-item gi-main__nav__primary-item'],
            btnClassName: ['dropdown__pos--01'],
            ariaClassName: ['extended-nav-section-one'],
            path: '#',
            type: HEADER_LINKS_TYPES.DROPDOWN,
            statesHasFeature: environment => environment.stateCode === IEX_STATE_CODES.GA,
            externalLink: '',
            dropdown: [
                {
                    name: 'Chat',
                    text: 'header.getAssistance.chat',
                    className: ['usa-nav__submenu-item'],
                    path: language => language === 'es' ? ENVIRONMENT_LINK_ENDPOINTS_NAMES.CHAT_NOT_LOGIN_ES : ENVIRONMENT_LINK_ENDPOINTS_NAMES.CHAT_NOT_LOGIN_EN,
                    type: HEADER_LINKS_TYPES.CHAT,
                    additionalProperties: {
                        target: '_blank',
                        rel: 'noopener noreferrer'
                    },
                    visible: environment => !environment.user,
                    externalLink: ''
                },
                {
                    name: 'Chat',
                    text: 'header.getAssistance.chat',
                    className: ['usa-nav__submenu-item'],
                    path: language => language === 'es' ? ENVIRONMENT_LINK_ENDPOINTS_NAMES.CHAT_LOGIN_ES : ENVIRONMENT_LINK_ENDPOINTS_NAMES.CHAT_LOGIN_EN,
                    type: HEADER_LINKS_TYPES.CHAT,
                    visible: environment => environment.user,
                    externalLink: ''
                },
                {
                    name: 'find-assistance',
                    className: ['usa-nav__submenu-item'],
                    text: 'header.getAssistance.localAssistance',
                    path: '#',
                    type: HEADER_LINKS_TYPES.MODAL,
                    modalName: MODAL_TYPES.LOCATE_ASSISTANCE_MODAL,
                    visible: environment => (environment.user && environment.user.role === ALL_USER_ROLES.INDIVIDUAL) || environment.impersonation || environment.anonymous,
                    externalLink: ''
                },
                {
                    name: 'faq',
                    text: 'header.getAssistance.faq',
                    className: ['usa-nav__submenu-item'],
                    linkClassName:[''],
                    path: ENVIRONMENT_LINK_ENDPOINTS_NAMES.HELP,
                    type: HEADER_LINKS_TYPES.LINK,
                    additionalProperties: {
                        target: '_blank',
                        rel: 'noopener noreferrer'
                    },
                },
                {
                    name: 'contact',
                    text: 'header.getAssistance.contactUs',
                    text_2: 'header.getAssistance.contactUs_number',
                    hasTextWithIcon: true,
                    className: ['usa-nav__submenu-item'],
                    path: ENVIRONMENT_LINK_ENDPOINTS_NAMES.PHONE,
                    symbol: 'phone',
                    symbolClassName: 'phone fa-flip-horizontal nav-phone-icon',
                    symbolPosition: 'middle',
                    type: HEADER_LINKS_TYPES.LINKS_AND_ICONS,
                    externalLink: ''
                }
            ]
        },
        {
            name: 'my-authentication',
            text: 'header.myAccount',
            className: ['usa-nav__primary-item gi-main__nav__primary-item'],
            btnClassName: ['dropdown__pos--02'],
            ariaClassName: ['extended-nav-section-two'],
            path: '#',
            type: HEADER_LINKS_TYPES.DROPDOWN,
            statesHasFeature: environment => [IEX_STATE_CODES.NV, IEX_STATE_CODES.NJ, IEX_STATE_CODES.PA, IEX_STATE_CODES.GA].some( state => state === environment.stateCode ),
            visible: (environment) => (!environment.anonymous),
            externalLink: '',
            dropdown: [
                {
                    name: 'authentication-settings',
                    text: 'header.myAccount.accountSettings',
                    className: ['usa-nav__submenu-item'],
                    path: ENVIRONMENT_LINK_ENDPOINTS_NAMES.SETTINGS,
                    type: HEADER_LINKS_TYPES.LINK,
                    externalLink: ''
                },
                {
                    name: 'dashboard',
                    text: 'header.myAccount.dashboard',
                    className: ['usa-nav__submenu-item'],
                    linkClassName:[''],
                    path: ENVIRONMENT_LINK_ENDPOINTS_NAMES.DASHBOARD,
                    type: HEADER_LINKS_TYPES.LINK,
                    externalLink: ''
                },
                {
                    name: 'logout',
                    text: 'header.myAccount.logout',
                    className: ['usa-nav__submenu-item'],
                    linkClassName:[],
                    path: ENVIRONMENT_LINK_ENDPOINTS_NAMES.LOGOUT,
                    type: HEADER_LINKS_TYPES.LINK,
                    extraAction: EXTRA_ACTIONS.CHECK_SSAP,
                    beforeClick: onLogout,
                    externalLink: ''
                }
            ]
        }
    ]
};